import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { FEATURE_CARD_LIST_CLASSNAME } from '@vfde-brix/ws10/feature-card/Constants';
import { createFeatureCard } from './FeatureCard';
createComponents(".".concat(FEATURE_CARD_LIST_CLASSNAME), createFeatureCard, NO_PATTERN_BUSINESS_LOGIC);
